export default "__VITE_ASSET__BFGP_j4z__"